export default __webpack_public_path__ + "f2a4f8a10aed4152574f98df4bb53100.woff?proxy=wpt-abc";